let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kjPPZ")).then(() => parcelRequire('7Y0pd'));